import React, { useEffect, useMemo } from 'react'
import { Container, Item, Badge, SubItemContainer } from './elements'
import { withRouter } from 'react-router-dom'
import { routes } from 'app/routes/DashboardRoutes'
import Icon from 'app/components/commons/Icon'
import { usePageAccessFeatureFlags } from 'app/hooks/usePageAccessFeatureFlag'
import posthog from 'posthog-js'
import { useDispatch, useSelector } from 'react-redux'
import * as selectors from 'app/selectors'
import { getProviderInfo } from 'app/actions/session'

const Sidebar = ({ location }) => {
  const dispatch = useDispatch()
  const { providerName, providerId } = useSelector(
    selectors.getProviderInformation
  )

  useEffect(() => {
    if (!providerName && !providerId) {
      dispatch(getProviderInfo())
    }
  }, [])

  const { blockedDatesAccess, advancedPricingAccess } =
    usePageAccessFeatureFlags(providerName, providerId)

  const filteredRoutes = useMemo(
    () =>
      routes
        .map((route) => {
          if (route.path === '/pricing') {
            if (route.subRoutes) {
              return {
                ...route,
                subRoutes: route.subRoutes.filter(
                  (subRoute) =>
                    (subRoute.path === '/blocked-dates' &&
                      blockedDatesAccess) ||
                    (subRoute.path === '/advanced-pricing' &&
                      advancedPricingAccess) ||
                    (subRoute.path !== '/blocked-dates' &&
                      subRoute.path !== '/advanced-pricing')
                ),
              }
            }
          }

          return route
        })
        .filter(Boolean),
    [blockedDatesAccess, advancedPricingAccess]
  )

  return (
    <Container>
      {filteredRoutes.map((route, index) => {
        const badgeFeatureFlag = () => {
          switch (route.path) {
            case '/pricing':
              return posthog.isFeatureEnabled('price_update_page_announcement')
            case '/reports':
              return posthog.isFeatureEnabled('reports_page_announcement')
            default:
              return false
          }
        }

        const subRouteBadgeFeatureFlag = (subRoutePath) => {
          switch (subRoutePath) {
            case '/blocked-dates':
              return posthog.isFeatureEnabled('blocked_dates_page_announcement')
            case '/advanced-pricing':
              return posthog.isFeatureEnabled(
                'advanced_pricing_page_announcement'
              )
            default:
              return false
          }
        }

        const showBadge = route.badge && badgeFeatureFlag()
        const hasSubRoutes = !!route.subRoutes
        const isActive = hasSubRoutes
          ? false
          : location.pathname.includes(route.pathTo)
        return (
          <React.Fragment key={`route-${index}`}>
            <Item to={route.pathTo} $active={isActive}>
              <Icon> {route.icon} </Icon>
              {route.name}
              {showBadge && <Badge>{route.badge}</Badge>}
              {hasSubRoutes && <Icon>keyboard_arrow_down</Icon>}
            </Item>

            {route.subRoutes && (
              <SubItemContainer>
                {route.subRoutes.map((subRoute, subIndex) => {
                  const showSubBadge =
                    subRoute.badge && subRouteBadgeFeatureFlag(subRoute.path)
                  return (
                    <Item
                      key={`route-${index}-subroute-${subIndex}`}
                      to={subRoute.pathTo}
                      $active={location.pathname.includes(subRoute.pathTo)}
                      style={{ paddingRight: 0 }}
                    >
                      <div style={{ paddingLeft: '34px' }}>{subRoute.name}</div>
                      {showSubBadge && <Badge>{subRoute.badge}</Badge>}
                    </Item>
                  )
                })}
              </SubItemContainer>
            )}
          </React.Fragment>
        )
      })}
    </Container>
  )
}

export default withRouter(Sidebar)
